export const seedDefaultLocale = 'en';
export const seedSupportedLocales = ['en', 'id'];
